import { render, staticRenderFns } from "./AddNewEventTask.vue?vue&type=template&id=25e2b5ec&scoped=true"
import script from "./AddNewEventTask.vue?vue&type=script&lang=ts"
export * from "./AddNewEventTask.vue?vue&type=script&lang=ts"
import style0 from "./AddNewEventTask.vue?vue&type=style&index=0&id=25e2b5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e2b5ec",
  null
  
)

export default component.exports